import { render, staticRenderFns } from "./valmistumispyynnot-vastuuhenkilo-yek.vue?vue&type=template&id=53a481eb&"
import script from "./valmistumispyynnot-vastuuhenkilo-yek.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-vastuuhenkilo-yek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports